import { createFileRoute, redirect } from "@tanstack/react-router";
import { GetAccessionQuery } from "generated/graphql";
import request from "graphql-request";
import { queryClient } from "src/app";
import config from "src/config";
import { getAccessionByIdDocument } from "src/features/collection/graphql";
import { getAccessionDocument } from "src/features/records/accession/graphql";
import { AccessTokenStore } from "src/utils/session";

export const Route = createFileRoute("/_layout/accession/$id")({
  loader: async ({ params: { id }, context: { subdomain } }) => {
    const accessToken = await AccessTokenStore.getAccessToken();
    const res = await queryClient.fetchQuery({
      queryKey: [
        (getAccessionByIdDocument.definitions[0] as any)?.name?.value,
        {
          id,
        },
      ],
      queryFn: ({ queryKey }) =>
        request(
          config.publicApiUrl,
          getAccessionByIdDocument,
          queryKey[1] == null ? undefined : queryKey[1],
          accessToken == null
            ? undefined
            : { authorization: `Bearer ${accessToken}` },
        ),
      staleTime: 60000,
    });

    if (res.accession?.collectionSite == null) {
      throw redirect({
        to: "/",
      });
    }

    const siteSlug = res.accession.collectionSite.urlSlug;
    const accessionNumber = res.accession.accessionNumber;

    queryClient.setQueryData<GetAccessionQuery>(
      [
        (getAccessionDocument.definitions[0] as any)?.name?.value,
        {
          organisationSubdomain: subdomain,
          collectionSiteSlug: siteSlug,
          accessionNumber,
        },
      ],
      { org: { site: { result: res.accession } } },
    );

    throw redirect({
      to: "/site/$siteSlug/accession/$accessionNumber",
      params: {
        siteSlug,
        accessionNumber,
      },
    });
  },
});
